<template>
    <b-row>
        <b-col cols="12" md="6">
            <b-card>
                <b-form-group :label="$t('name')">
                    <protokol-invalid-feedback :errors="validator.fieldErrors('name')">
                        <b-input v-model="name" />
                    </protokol-invalid-feedback>
                </b-form-group>

                <b-form-group :label="$t('type')">
                    <div class="type-selector">
                        <div 
                            class="type-option" 
                            :class="{ active: model.type === 'public' }"
                            @click="model.type = 'public'"
                        >
                            <b-icon icon="globe" font-scale="2"></b-icon>
                            <div class="type-label">Public</div>
                            <small class="type-description">{{ $t('publicAppDescription') }}</small>
                        </div>
                        <div
                            class="type-option"
                            :class="{ active: model.type === 'platform' }"
                            @click="model.type = 'platform'"
                        >
                            <b-icon icon="server" font-scale="2"></b-icon>
                            <div class="type-label">Platform</div>
                            <small class="type-description">{{ $t('platformAppDescription') }}</small>
                        </div>
                        <div
                            class="type-option"
                            :class="{ active: model.type === 'service' }"
                            @click="model.type = 'service'"
                        >
                            <b-icon icon="gear-wide-connected" font-scale="2"></b-icon>
                            <div class="type-label">Service</div>
                            <small class="type-description">{{ $t('serviceAppDescription') }}</small>
                        </div>
                    </div>
                </b-form-group>

                <b-button @click="save" variant="success"> {{ $t('save') }} </b-button>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>

export default {
    name: 'FunctionCreate',
    components: {},
    data: function () {
        return {
            validator: this.$validator(),
            model: {
                name: "",
                type: "public"
            }
        }
    },

    watch: {
        model: {
            handler: function () {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    computed: {
        name: {
            get() {
                return this.model.name.replaceAll(" ", "_").replaceAll(/[0-9]/g, "")
            },

            set(val) {
                this.model.name = val.replaceAll(" ", "_").replaceAll(/[0-9]/g, "")
            }
        }
    },
    methods: {
        save() {
            if (!this.validator.pass()) return

            let popup = this.$loadingPopup()
            this.$http.post(`/luma/appservice/v1/forge`, this.model).then((resp) => {
                this.$router.push(`/admin/forge/${resp.data.uuid}`)
            }).catch(err => {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    created() {
        this.validator.validate(this.model, {
            isValidDNSName: (model, errors) => {
                if (model.name.length < 1) {
                    errors.add('name', [this.$t('requiredField')])
                    return
                }

                if (model.name.length < 3) {
                    errors.add('name', [this.$t('notValid')])
                }
            },
        })
    }
}
</script>

<style scoped lang="scss">
.type-selector {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 20px;
}

.type-option {
    padding: 24px;
    border: 2px solid var(--border-default);
    border-radius: 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: var(--bg-card);
    
    &:hover {
        border-color: var(--border-hover);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    &.active {
        border-color: var(--primary-start);
        background: var(--step-inactive-bg);
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
        
        .type-label {
            color: var(--primary-start);
        }
    }
    
    .b-icon {
        color: var(--text-primary);
        margin-bottom: 12px;
    }
    
    .type-label {
        font-size: 16px;
        font-weight: 600;
        color: var(--text-primary);
        margin-bottom: 8px;
    }
    
    .type-description {
        display: block;
        color: var(--text-muted);
        font-size: 12px;
    }
}
</style>
